import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs, doc, getDoc } from "firebase/firestore";
import "./TechNews.css";

const TechNews = () => {
  const [posts, setPosts] = useState([]);
  const [lastUpdated, setLastUpdated] = useState(null);

  // Fallback data in case Firebase is not available
  const fallbackPosts = [
    {
      title: "Weekly Tech Headlines Coming Soon",
      description: "This section will automatically populate with the latest tech news from trusted sources. The automated system is currently being configured.",
      url: "https://news.ycombinator.com",
      source: "System Update",
      publishedAt: new Date().toISOString()
    },
    {
      title: "Automated News Curation in Progress",
      description: "Our Firebase function is being deployed to fetch and curate the most relevant tech stories each week from multiple trusted sources.",
      url: "https://techcrunch.com",
      source: "System Update", 
      publishedAt: new Date().toISOString()
    },
    {
      title: "Real Tech News Loading Soon",
      description: "Once the cron job is deployed, this section will feature real-time updates with the latest developments in technology, AI, and software engineering.",
      url: "https://arstechnica.com",
      source: "System Update",
      publishedAt: new Date().toISOString()
    }
  ];

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "techPosts"));
        const postData = [];
        querySnapshot.forEach((doc) => {
          if (doc.id !== "meta") {
            postData.push(doc.data());
          }
        });

        // Sort by publish date if available
        postData.sort((a, b) =>
          a.publishedAt && b.publishedAt
            ? new Date(b.publishedAt) - new Date(a.publishedAt)
            : 0
        );

        if (postData.length > 0) {
          setPosts(postData);
        } else {
          // Use fallback data if no posts in Firebase
          setPosts(fallbackPosts);
        }

        // Fetch last updated timestamp
        const metaDoc = await getDoc(doc(db, "techPosts", "meta"));
        if (metaDoc.exists()) {
          setLastUpdated(metaDoc.data().lastUpdated);
        } else {
          // Set a default timestamp
          setLastUpdated({ seconds: Math.floor(Date.now() / 1000) });
        }
      } catch (error) {
        console.error("Error fetching tech news:", error);
        // Use fallback data on error
        setPosts(fallbackPosts);
        setLastUpdated({ seconds: Math.floor(Date.now() / 1000) });
      }
    };

    fetchPosts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="tech-news-container">
      <div className="tech-news-card">
        <h2 className="tech-news-title">Weekly Top Tech Headlines</h2>
        <p className="tech-news-description">
          Curated by AI and updated automatically each week with the latest news
          in tech from trusted sources.
        </p>
        <p className="tech-news-updated">
          Last updated:{" "}
          {lastUpdated
            ? new Date(lastUpdated.seconds * 1000).toLocaleString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
              })
            : "Loading..."}
        </p>

        {posts.map((post, index) => (
          <div key={index} className="tech-news-item">
            <a
              href={post.url}
              target="_blank"
              rel="noopener noreferrer"
              className="tech-news-link"
            >
              <h3>{post.title}</h3>
            </a>
            <div className="tech-news-source">{post.source}</div>
            <p className="tech-news-text">{post.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TechNews;
